import { render, staticRenderFns } from "./AxCreateProjectRp.vue?vue&type=template&id=e48bd9f2&scoped=true&"
import script from "./AxCreateProjectRp.vue?vue&type=script&lang=ts&"
export * from "./AxCreateProjectRp.vue?vue&type=script&lang=ts&"
import style0 from "./AxCreateProjectRp.vue?vue&type=style&index=0&id=e48bd9f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48bd9f2",
  null
  
)

export default component.exports